import * as React from "react";
const IconCrying = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || "48"}
    height={props.size || "48"}
    
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      
      d="M31.425 38.177A15.9 15.9 0 0 1 24 40c-8.837 0-16-7.163-16-16S15.163 8 24 8s16 7.163 16 16q0 .25-.008.5h2.001Q42 24.25 42 24c0-9.941-8.059-18-18-18S6 14.059 6 24s8.059 18 18 18c3.025 0 5.876-.746 8.379-2.065z"
    />
    <path
      
      d="M13.743 23.35c-.12.738.381 1.445 1.064 1.883.714.457 1.732.707 2.93.53a3.8 3.8 0 0 0 2.654-1.665c.504-.764.711-1.693.48-2.382a.5.5 0 0 0-.818-.203c-1.796 1.704-3.824 2.123-5.642 1.448a.5.5 0 0 0-.668.39M33.819 23.35c.119.738-.382 1.445-1.065 1.883-.714.457-1.731.707-2.93.53a3.8 3.8 0 0 1-2.653-1.665c-.504-.764-.712-1.693-.48-2.382a.5.5 0 0 1 .818-.203c1.796 1.704 3.824 2.123 5.642 1.448a.5.5 0 0 1 .668.39"
    />
    <path
      
      fillRule="evenodd"
      d="M36 36a4 4 0 0 0 4-4c0-3.5-4-7-4-7s-4 3.5-4 7a4 4 0 0 0 4 4m0-2a2 2 0 0 0 2-2c0-1.066-.654-2.37-1.59-3.6q-.207-.27-.41-.512-.203.241-.41.512C34.655 29.63 34 30.934 34 32a2 2 0 0 0 2 2"
      clipRule="evenodd"
    />
    <path
      
      d="M20.8 33.6c1.6-2.133 4.8-2.133 6.4 0a1 1 0 0 0 1.6-1.2c-2.4-3.2-7.2-3.2-9.6 0a1 1 0 0 0 1.6 1.2"
    />
  </svg>
);
export default IconCrying;
